import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const HomeBasedLearningSupportProgramPageSession = React.lazy(() => import('../programs/homebasedlearningsupportprogram/HomeBasedLearningSupportProgramPageSession'));
const HomeBasedLearningSupportProgramPageHeader = React.lazy(() => import('../programs/homebasedlearningsupportprogram/HomeBasedLearningSupportProgramPageHeader'));

function HomeBasedLearningSupportProgramPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <HomeBasedLearningSupportProgramPageHeader />
       <HomeBasedLearningSupportProgramPageSession />
      </Suspense>
    </div>
  );
}

export default HomeBasedLearningSupportProgramPage;
